import { useState } from "react";
import { useNavigate } from "react-router-dom";
import chemistryIcon from "../../../asstes/icons/subjectdashboard/chemistry.png";
import physicsIcon from "../../../asstes/icons/subjectdashboard/atom.png";
import biologyIcon from "../../../asstes/icons/subjectdashboard/molecular.png";
import { useTranslation } from "react-i18next";

export default function SubjectsDashboard() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedClass, setSelectedClass] = useState("");

  const classes = ["6", "7", "8", "9", "10"];

  const handleNavigate = (subject) => {
    if (!selectedClass) return alert(t("virtualLab.selectClass"));
    navigate(`/dashboard/student/${subject}?class=${selectedClass}`);
  };

  return (
    <div className="relative min-h-[calc(100vh-120px)] overflow-hidden bg-[#fdf8ff] flex flex-col items-center pt-10">

      {/* Wavy Background Shape */}
      {/* <div className="absolute top-0 left-0 w-full h-72 bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 opacity-90 rounded-b-[50%] blur-[1px]"></div> */}

      {/* Floating sparkles */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full opacity-60 animate-sparkle"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 3}s`,
            }}
          ></div>
        ))}
      </div>

      {/* Title */}
      <h1 className="text-4xl font-extrabold text-black drop-shadow-lg tracking-wide mb-12 relative z-[5]">
        {t("virtualLab.labTitle")}
      </h1>

      {/* CLASS SELECTOR — Capsule Button Bar */}
      <div className="flex gap-3 mb-10 relative z-[5] bg-white/80 backdrop-blur-md p-3 px-5 rounded-full shadow-lg">
        {classes.map((cls) => (
          <button
            key={cls}
            onClick={() => setSelectedClass(cls)}
            className={`px-5 py-2 rounded-full text-sm font-semibold transition-all 
              ${
                selectedClass === cls
                  ? "bg-black text-white shadow-lg scale-105"
                  : "bg-white text-gray-700 hover:bg-purple-100"
              }`}
          >
            {t("virtualLab.class")} {cls}
          </button>
        ))}
      </div>

      {/* Subjects */}
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-5xl px-4 relative z-[5]">

        {/* CARD TEMPLATE */}
        {[
          {
            title: t("virtualLab.chemistry"),
            icon: chemistryIcon,
            colors: "from-blue-500 to-indigo-600",
            subject: "chemistry",
            glow: "shadow-[0_0_20px_rgba(59,130,246,0.6)]",
          },
          {
            title: t("virtualLab.physics"),
            icon: physicsIcon,
            colors: "from-yellow-500 to-orange-600",
            subject: "physics",
            glow: "shadow-[0_0_20px_rgba(251,191,36,0.6)]",
          },
          {
            title: t("virtualLab.biology"),
            icon: biologyIcon,
            colors: "from-green-500 to-teal-600",
            subject: "biology",
            glow: "shadow-[0_0_20px_rgba(16,185,129,0.6)]",
          },
        ].map((item) => (
          <div
            key={item.title}
            onClick={() => handleNavigate(item.subject)}
            className={`relative cursor-pointer bg-gradient-to-br ${item.colors} 
              text-white rounded-3xl p-6 py-8 shadow-xl hover:scale-110 
              transition-all duration-300 hover:${item.glow} overflow-hidden`}
          >
            {/* orbit rings */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-40 h-40 border-2 border-white/30 rounded-full animate-orbit"></div>
              <div className="w-24 h-24 border-2 border-white/20 rounded-full animate-orbit-slow"></div>
            </div>

            {/* Content */}
            <div className="relative z-[5] flex flex-col items-center text-center">
              <img
                src={item.icon}
                className="h-16 w-16 mb-4 bg-white rounded-2xl p-3 shadow-md"
              />
              <h4 className="text-xl font-extrabold drop-shadow-md">{item.title}</h4>
              <p className="text-sm text-white/90 mt-1">
                <p>{t("virtualLab.desc")}</p>
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Custom Animations */}
      <style>
        {`
          @keyframes sparkle {
            0% { transform: translateY(0px); opacity: 0.7; }
            50% { transform: translateY(-20px); opacity: 1; }
            100% { transform: translateY(0px); opacity: 0.7; }
          }
          .animate-sparkle {
            animation: sparkle ease-in-out infinite;
          }

          @keyframes orbit {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animate-orbit {
            animation: orbit 9s linear infinite;
          }
          .animate-orbit-slow {
            animation: orbit 14s linear infinite;
          }
        `}
      </style>
    </div>
  );
}
